import { useSelector } from 'react-redux';
import { formatStatisticalNumberOutput, getStatePropertyItemsCount } from '@helpers/customerHelpers';

export function RecentsCounter() {
    const recents = useSelector((state: any) => state.recents);
    const recentsCount = getStatePropertyItemsCount(recents?.products);

    return (
        <span className="product-tabs__count product-tabs__count--recently">
            {formatStatisticalNumberOutput(recentsCount)}
        </span>
    );
}
